import React from 'react'

const FileTypeIcon = ({ type, size = 40 }) => {
    switch (type) {
        case "pdf":
            return (
                <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width={40} height={40} style={{width: size, height: size}} fill="none">
                    <path
                        stroke="#D5D7DA"
                        strokeWidth="1.5"
                        d="M7.75 4A3.25 3.25 0 0 1 11 .75h16c.121 0 .238.048.323.134l10.793 10.793a.46.46 0 0 1 .134.323v24A3.25 3.25 0 0 1 35 39.25H11A3.25 3.25 0 0 1 7.75 36z"
                    />
                    <path stroke="#D5D7DA" strokeWidth="1.5" d="M27 .5V8a4 4 0 0 0 4 4h7.5" />
                    <rect width="26" height="16" x="1" y="18" fill="#D92D20" rx="2" />
                    <path
                        fill="#fff"
                        d="M4.832 30v-7.273h2.87q.826 0 1.41.316.582.314.887.87.31.555.31 1.279t-.313 1.278q-.313.555-.906.863-.59.309-1.427.309h-1.83V26.41h1.581q.444 0 .732-.153.29-.156.433-.43.145-.276.145-.635 0-.363-.145-.632a.97.97 0 0 0-.433-.423q-.291-.153-.74-.153H6.37V30zm9.053 0h-2.578v-7.273h2.6q1.095 0 1.889.437.791.433 1.218 1.246.43.814.43 1.947 0 1.136-.43 1.953a2.95 2.95 0 0 1-1.226 1.253q-.795.437-1.903.437m-1.04-1.317h.976q.682 0 1.147-.242.47-.244.703-.756.238-.516.238-1.328 0-.807-.238-1.318a1.54 1.54 0 0 0-.7-.753q-.465-.24-1.146-.241h-.98zM18.582 30v-7.273h4.816v1.268H20.12v1.733h2.958v1.268H20.12V30z"
                    />
                </svg>
            );
        case "image":
            return (
                <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width={40} height={40} style={{width: size, height: size}} fill="none">
                    <path
                        stroke="#D5D7DA"
                        strokeWidth="1.5"
                        d="M7.75 4A3.25 3.25 0 0 1 11 .75h16c.121 0 .238.048.323.134l10.793 10.793a.46.46 0 0 1 .134.323v24A3.25 3.25 0 0 1 35 39.25H11A3.25 3.25 0 0 1 7.75 36z"
                    />
                    <path stroke="#D5D7DA" strokeWidth="1.5" d="M27 .5V8a4 4 0 0 0 4 4h7.5" />
                    <rect width="26" height="16" x="1" y="18" fill="#7F56D9" rx="2" />
                    <path
                        fill="#fff"
                        d="M6.39 22.727V30H4.851v-7.273zm1.265 0H9.55l2.003 4.887h.085l2.003-4.887h1.896V30h-1.491v-4.734h-.06l-1.883 4.699H11.09l-1.883-4.716h-.06V30H7.655zm13.972 2.351a1.6 1.6 0 0 0-.21-.458q-.135-.203-.33-.34a1.4 1.4 0 0 0-.44-.218 1.9 1.9 0 0 0-.543-.074q-.558 0-.98.277-.42.277-.654.806-.234.526-.234 1.285 0 .76.23 1.293.233.533.654.813.423.277.998.277.522 0 .892-.184.373-.188.568-.53.198-.34.198-.805l.313.046h-1.875v-1.158h3.043v.916q0 .96-.405 1.648-.405.686-1.114 1.058-.71.37-1.627.37-1.022 0-1.797-.452a3.13 3.13 0 0 1-1.207-1.289q-.43-.837-.43-1.988 0-.884.256-1.577.26-.696.724-1.179.465-.483 1.083-.735a3.5 3.5 0 0 1 1.34-.252q.617 0 1.15.18.533.179.944.505.415.327.678.778.264.447.338.987z"
                    />
                </svg>
            );
        default:
            // text/code
            return (
                <svg viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg" width={40} height={40} style={{width: size, height: size}} fill="none">
                    <path
                        stroke="#D5D7DA"
                        strokeWidth="1.5"
                        d="M4.75 4A3.25 3.25 0 0 1 8 .75h16c.121 0 .238.048.323.134l10.793 10.793a.46.46 0 0 1 .134.323v24A3.25 3.25 0 0 1 32 39.25H8A3.25 3.25 0 0 1 4.75 36z"
                    />
                    <path stroke="#D5D7DA" strokeWidth="1.5" d="M24 .5V8a4 4 0 0 0 4 4h7.5" />
                    <path
                        stroke="#155EEF"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="1.5"
                        d="M11.9 19.5h16.2m-16.2 3.6h16.2m-16.2 3.6h16.2m-16.2 3.6h12.6"
                    />
                </svg>
            );
    }
};

export default FileTypeIcon
